module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADrSURBVDiNzdE9TsNAEIbhd/xDnSNwhHACbwtu3Cz1ij0Iyg18ARLTEgo3oc0RotwgR3BLHDE0IbIQG7JRhPiklWak2UcjjRBIVbnR+1VqEqRQ/Vi/zadNaHaYbNjc3vsqQQpUTQ/jRAEUQQDiwNL6JYoBDQ6X1s8OjUiXb3eTtm260IbmhAXcoVKlz1MD3ITA3yNDkAYYfx+JAhcvT89fdWl989NMEgOekmPgBpH6cqBIm293k8uBqq7P01UseOwoo/2Lyp8e5X+A2Z19cIIU5wKl9TNU14vXaQ2QCfIIXJ9hbfb/HCIdUAN8Alw2PGaKH8CCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy2.png
// module id = LokZ
// module chunks = 1